/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */


import * as React from "react";
import {useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import axios from "axios";
import category from "../../cards/Category/Category";

const CreateProductDialog = ({open, setOpen, category}) => {
    const [title, setTitle] = React.useState(""), [weight, setWeight] = React.useState(""), [subscr, setSubscr] = React.useState(""), [price, setPrice] = React.useState(""),
        handleClickOpen = () => {
            setOpen(true);
        }, [file, setFile] = useState(null), HandleFileChange = (e) => {
            console.log(e.target.files)
            const file = e.target.files[0]

            if (file) {
                setFile(file)
            }
        }, handleClose = () => {
            setOpen(false);
        };

    return (
        <div>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Создать категорию</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Введите данные для создания категории
                    </DialogContentText>
                    <TextField fullWidth margin="normal" id="filled-basic" label="Название" value={title}  onChange={(event)=>{setTitle(event.target.value)}} variant="filled" />
                    <TextField fullWidth margin="normal" id="filled-basic" label="Вес" value={weight}  onChange={(event)=>{setWeight(event.target.value)}} variant="filled" />
                    <TextField fullWidth margin="normal" id="filled-basic" label="Описание" value={subscr}  onChange={(event)=>{setSubscr(event.target.value)}} variant="filled" />
                    <TextField fullWidth margin="normal" id="filled-basic" label="цена" value={price}  onChange={(event)=>{setPrice(event.target.value)}} variant="filled" />
                    <br/>
                    <input type='file' onChange={(event)=>{HandleFileChange(event)}} accept='.png'/>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={()=>{
                        console.log(file.filename)
                        console.log(file.name)
                        CreateProduct(title,file.name, weight,subscr,price,category)
                        const fd = new FormData();
                        if(file != null){
                        fd.append("file",file)
                        SendPhoto(fd, file.name);
                        setOpen(false)}
                    }}>Создать</Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}

const CreateProduct = (titlein, imgin, weightin, subscriptionin, pricein, catidin) => {
    axios.post("https://kudiyarapi.gigagile.space/products", {
        title: titlein,
        img: imgin,
        weight: weightin,
        subscription: subscriptionin,
        price: pricein,
        category_id: catidin

    }, {
        headers : {
            "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "*"
        }
    }
).then((res)=> {console.log(catidin)});
}
const SendPhoto = (FormData) =>{
    axios.post(`https://photoapi.gigagile.space/upload`, FormData)
        .then((response) => {
            console.log('File uploaded:', response.data);
            // Do something with the response from the backend
        })
        .catch((error) => {
            console.error('Error uploading file:', error);
        });
}
export default CreateProductDialog;